var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full pb-10" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.$apollo.queries.requestData.loading,
            hasData: !!_vm.requestData,
          },
        },
        [
          _vm.requests
            ? _c(
                "RequestHeader",
                {
                  attrs: { request: _vm.requests, userRole: _vm.role },
                  on: { edit: _vm.enableEditMode },
                },
                [
                  _c(
                    "PageHeadIcon",
                    { attrs: { content: _vm.budget } },
                    [
                      _c("DollarIcon", {
                        staticClass:
                          "mr-1 h-5 w-5 text-primary-500 group-hover:text-gray-500 group-focus:text-gray-500",
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("TabsWithRoutes", {
            attrs: { routeTabs: _vm.routeTabs },
            on: { tabChanged: _vm.refetchTabData },
            scopedSlots: _vm._u(
              [
                _vm.suggestedResourcesCount
                  ? {
                      key: _vm.routes.CUSTOM_REQUESTS_RESOURCES_SUGGESTED,
                      fn: function () {
                        return [
                          _c("span", { staticClass: "mr-1.5" }, [
                            _vm._v("Suggested Resources"),
                          ]),
                          _c("TabNotificationBubble", {
                            attrs: {
                              notification: _vm.suggestedResourcesCount,
                              info: "",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
          _c("router-view", { attrs: { request: _vm.requests[0] } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }